'use client';

import Link from '@eliadmin/core/src/components/link';

import { SignInDialog } from '@eliadmin/core/src/components/dialog/lazy-dialogs';
import { prefetchSocialAuthProviders } from '@eliadmin/core/src/components/auth/social-auth-buttons';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useDialogStore } from '@eliadmin/core/src/components/ui/dialog';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { FiUser } from 'react-icons/fi';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export const HeaderProfileButton = ({ isHomepage }: { isHomepage: boolean }) => {
  const { t } = useTranslations();
  const me = useCustomerStore(s => s.me);
  const locale = useLocaleStore(s => s.currentLocale);

  const openDialog = useDialogStore(s => s.open);

  const warmSocialAuthProviders = () => {
    void prefetchSocialAuthProviders(locale);
  };

  const handleSignInClick = () => {
    warmSocialAuthProviders();
    openDialog({
      id: SignInDialog.id,
      content: <SignInDialog />,
    });
  };

  if (!me) {
    return (
      <Button
        variant={'none'}
        onClick={handleSignInClick}
        className={cn(
          isHomepage ? 'border border-white text-white hover:bg-white/10' : 'text-black',
        )}
      >
        {t('text190')}
      </Button>
    );
  }

  return (
    <Button
      asChild
      className={cn(
        'ea-header-profile-button h-12 w-12 min-w-[48px] shrink-0 border-0 p-0',
        isHomepage ? 'text-white hover:bg-white/10' : 'text-primary',
      )}
      size={'none'}
      variant={'none'}
    >
      <Link prefetch={false} href={ROUTES.PROFILE()} aria-label={t('text190')}>
        <FiUser size={32} aria-hidden="true" />
      </Link>
    </Button>
  );
};
